module.exports = __webpack_public_path__ + "vennProvidedLogo.874c218191adc577ea4f043f46381c92.png";